import { PureComponent } from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import mapProps from 'map-props';
import elementType from 'prop-types-extra/lib/elementType';
import Item from './Item';
import propsMapping from './propsMapping';

class Control extends PureComponent {
  static propTypes = {
    input: PropTypes.object.isRequired,
    options: PropTypes.array,
    Container: elementType.isRequired,
    showOnlySelectedOption: PropTypes.bool,
  };

  static defaultProps = {
    showOnlySelectedOption: false,
  };

  render() {
    const { Container, input, options, showOnlySelectedOption, ...itemProps } =
      this.props;

    return (
      <Container>
        {options.map((option, index) => {
          if (
            option.value !== get(['value'], input) &&
            showOnlySelectedOption
          ) {
            return null;
          }

          return (
            <Item
              {...itemProps}
              input={input}
              key={`${index}_${option.value}`}
              option={option}
            />
          );
        })}
      </Container>
    );
  }
}

export default mapProps(propsMapping)(Control);
